"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M13.5 4c0 .234-.054.455-.15.653A6 6 0 0 1 18 10.5V13c0 .503.323.868.83 1.311l.134.117c.2.172.423.364.597.56.221.25.439.583.439 1.012v.5a1.5 1.5 0 0 1-1.5 1.5h-3.6a3.5 3.5 0 0 1-.633 1.426C13.754 20.095 12.98 20.5 12 20.5s-1.753-.405-2.268-1.074A3.5 3.5 0 0 1 9.101 18H5.5A1.5 1.5 0 0 1 4 16.5V16c0-.429.217-.763.439-1.012.174-.196.397-.388.596-.56l.136-.117C5.677 13.868 6 13.503 6 13v-2.5a6 6 0 0 1 4.65-5.847A1.5 1.5 0 1 1 13.5 4m-1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M10.13 18c.09.318.223.594.395.816.321.418.798.684 1.475.684s1.154-.266 1.475-.684c.172-.223.306-.498.395-.816z"
}), 'NotificationFilled');
